import { connect } from 'react-redux'
import NominativeForm from './NominativeForm.jsx'
import { getCollaborativeIndexationCreationFields } from '../../../../../../redux/collaborativeIndexations/selectors'

const mapStateToProps = (state) => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const NominativeFormContainer = connect(
    mapStateToProps,
)(NominativeForm)
